import i18next from "i18next";
import { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import CuriorAdressInfo from "../../../Components/curiors/show/curioraddress";
import CuriorAttachments from "../../../Components/curiors/show/curiorattachments";
import CurioerAttendance from "../../../Components/curiors/show/curiorAttendance";
import CuriorInfo from "../../../Components/curiors/show/curiorinfo";
import CuriorsOrders from "../../../Components/curiors/show/curiororders";
import CuriorShift from "../../../Components/curiors/show/curiorShift";
import CuriorStatusCard from "../../../Components/curiors/show/curiorstatuscard";
import CuiorWallet from "../../../Components/curiors/show/curiorwallet";
import HeaderBar from "../../../Components/UI/headerbar";
import LoadingSpinner from "../../../Components/UI/spinner";
import StatsCard from "../../../Components/UI/staticsCard";
import { showCurios } from "../../../MyApi/curior";
import { CuriorStatsConfig, tabs } from "./config";

const CuriorShowPage = () => {
  const { id } = useParams();
  const lang = i18next.language;
  const [activeTab, setActiveTab] = useState("account");
  const [selectedLangCode, setSelectedLangCode] = useState(lang);
  const { data, isLoading, refetch } = useQuery(
    ["showCurios", id, selectedLangCode],
    () => showCurios(id, selectedLangCode),
  );

  const Curios = data?.data?.couier || {};
  const {
    avatar,
    status,
    name,
    email,
    id: driverId,
    avg_rate,
    phone,
    address,
    vehicle,
    stats,
    attachments,
    created_at,
    zones,
    currency_factor
  } = Curios;
  if (isLoading) {
    return <LoadingSpinner />;
  }

const curioerStats = CuriorStatsConfig(stats, currency_factor);
  return (
    <div>
      <HeaderBar
        title={"تفاصيل السائق"}
        content={"عرض وإدارة معلومات السائق"}
        isBack={true}
      />

      <CuriorStatusCard
        avatar={avatar}
        status={status}
        name={name}
        email={email}
        driverId={driverId}
        avg_rate={avg_rate}
        statusApi={status}
        refetch={refetch}
        id={id}
      />

      <div className="row">
        {curioerStats.map((stats, i) => (
          <div className="col" key={i}>
            <StatsCard {...stats} />
          </div>
        ))}
      </div>

      <div className="card rounded-3 shadow-sm ">
        <div className="card-body">
          <div className="rounded-4 bg-smoke p-2 px-3">
            <ul className="row">
              {tabs.map((tab) => (
                <li
                  className={`col-md text-center p-2 ${
                    activeTab === tab.label ? "bg-white rounded-4" : ""
                  }`}
                  key={tab.id}
                  onClick={() => setActiveTab(tab.label)}
                >
                  {tab.name}
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-3">
            {activeTab === "account" && (
              <CuriorInfo
                name={name}
                email={email}
                phone={phone}
                avg_rate={avg_rate}
                status={status}
                vehicle={vehicle}
                created_at={created_at}
              />
            )}
            {activeTab === "location" && (
              <CuriorAdressInfo {...address} zones={zones} />
            )}
            {activeTab === "workingDays" && (
              <CuriorShift
                id={id}
                refetch={refetch}
                storeId={Curios.store.id}
              />
            )}
            {activeTab === "attendance" && <CurioerAttendance id={id} />}
            {activeTab === "orders" && (
              <CuriorsOrders id={id} storeId={Curios.store.id} />
            )}
            {activeTab === "wallet" && (
              <CuiorWallet
                id={id}
                stats={stats.wallet}
                total_earnings={stats.total_earnings}
                factor={currency_factor}
              />
            )}
            {activeTab === "attachments" && (
              <CuriorAttachments attachments={attachments} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CuriorShowPage;
